<template>
  <v-dialog persistent v-model="openModal" max-width="800px">
    <v-form ref="formResponder">
      <v-card>
        <v-card-title
          class="primary body-2 white--text"
        >Responder Solicitação {{dataModal.dataSolicitacao | date }}</v-card-title>
        <v-card-text style="margin-top: 20px">
          <div class="mx-2 my-2">
            <alert></alert>
          </div>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                disabled
                v-uppercase
                outlined
                label="Nome"
                v-model="dataModal.usuario.nome"
              />
            </v-col>
            <v-col cols="12" md="4">
              <custom-input-mask
                outlined
                disabled
                label="CPF"
                :mask="['###.###.###-##']"
                v-model="dataModal.usuario.cpf"
              ></custom-input-mask>
            </v-col>
            <v-col cols="12" md="4">
              <custom-input-mask
                outlined
                disabled
                label="Celular"
                :mask="['(##)####-####', '(##)#####-####']"
                v-model="dataModal.usuario.celular"
              ></custom-input-mask>
            </v-col>
            <v-col cols="12" md="12">
              <v-textarea
                v-model="dataModal.resposta"
                solo
                :rules="requiredRule"
                ref="txtResposta"
                name="input-7-4"
                label="digite a resposta"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="fecharModal()" color="error">
            <v-icon left>mdi-close-circle</v-icon>Cancelar
          </v-btn>
          <v-btn @click="submit()" color="primary">
            <v-icon left>mdi-content-save</v-icon>Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import rules from "@/utils/rules";
import { mapActions } from "vuex";
import Alert from "../../components/helper/Alert";
import CustomInputMask from "../../components/shared/CustomInputMask";

export default {
  mixins: [rules],
  components: {
    Alert,
    CustomInputMask,
  },
  props: {
    openModal: {
      type: Boolean,
      required: true,
    },
    current: {
      type: [Object, Boolean],
      default: false,
    },
    callback: {
      type: [Boolean, Function],
      default: false,
    },
  },
  data() {
    return {
      dataModal: { usuario: {} },
    };
  },
  watch: {
    openModal(novoValor) {
      if (novoValor === true) {
        this.dataModal.id = this.current.id;
        this.dataModal.tipo = this.current.tipo;
        this.dataModal.dataSolicitacao = this.current.dataSolicitacao;
        this.dataModal.resposta = "";
        this.dataModal.usuario.id = this.current.usuario.id;
        this.dataModal.usuario.nome = this.current.usuario.nome;
        this.dataModal.usuario.cpf = this.current.usuario.cpf;
        this.dataModal.usuario.celular = this.current.usuario.celular;
        if (this.$refs.txtResposta) {
          setTimeout(() => this.$refs.txtResposta.focus(), 100);
        }
      } else {
        this.limparDados();
      }
    },
  },
  created() {},
  computed: {},
  methods: {
    ...mapActions("solicitacao", ["atualizar"]),

    submit() {
      if (this.$refs.formResponder.validate()) {
        this.atualizar({
          id: this.dataModal.id,
          idUsuario: this.dataModal.usuario.id,
          chave: this.dataModal.chave,
          dataSolicitacao: this.dataModal.dataSolicitacao,
          resposta: this.dataModal.resposta,
          dataResposta: new Date(),
        }).then((data) => {
          this.openAlertSuccess("Usuário atualizado com sucesso");
          this.fecharModal();
          if (this.callback) {
            this.callback(data);
          }
        });
      }
    },
    limparDados() {
      this.dataModal.id = 0;
      this.dataModal.tipo = 0;
      this.dataModal.dataSolicitacao = null;
      this.dataModal.resposta = null;
      this.dataModal.usuario.id = 0;
      this.dataModal.usuario.nome = null;
      this.dataModal.usuario.cpf = null;
      this.dataModal.usuario.celular = null;
    },
    fecharModal() {
      this.$emit("update:openModal", false);
    },
  },
};
</script>
